import { useEffect, useRef, useState } from 'react';
import { CouponHistoryModel } from '../../../models/couponHistory';
import { CustomerProfileModel } from '../../../models/customerProfile';
import axios from '../../../lib/axios';
import { FIND_MANY_COUPON_HISTORY } from '../../../lib/endpoints/coupon';
import { CUSTOMER_FIND_MANY } from '../../../lib/endpoints/customer';
import { MERCHANT_STORE_FIND_MANY } from '../../../lib/endpoints/merchant';
import { MerChantModel } from '../../../models/merChantModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { convertDateStringToNormalString } from '../../../utils/convertDateFormat';
import moment from 'moment';
import { SelectChangeEvent } from '@mui/material';

const useCouponHistoryController = () => {
  const [couponData, setCouponData] = useState<CouponHistoryModel[]>([]);
  const [merchantData, setMerchantData] = useState<MerChantModel[]>([]);

  const [merchantValue, setMerchantValue] = useState<string>(null!);
  const [searchValue, setSearchValue] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [loadingData, setLoadingData] = useState<boolean>(false);

  const [date, setDate] = useState<any>(null!);

  const assignMerchantToAdmin = useSelector((state: RootState) => state?.auth?.data?.merchants);
  const adminRole = useSelector((state: RootState) => state.auth?.data?.role?.role_type);

  //-------- fetchData ------------//

  const handleFetchData = async () => {
    try {
      setLoadingData(true);
      const couponRes = await axios.post(FIND_MANY_COUPON_HISTORY);
      const resCustomerProfile = await axios.post(`${CUSTOMER_FIND_MANY}?limit=${1000000}`);
      const branchResponse = await axios.get(MERCHANT_STORE_FIND_MANY);

      if (branchResponse?.data?.length > 0) {
        const matchingMerchants = branchResponse.data.filter((merchant: any) =>
          assignMerchantToAdmin?.includes(merchant?.id)
        );

        if (adminRole === 'SUPER_ADMIN') {
          setMerchantData(branchResponse?.data);
          setMerchantValue(branchResponse?.data[0]?.id);
        } else if (adminRole === 'ADMIN') {
          if (matchingMerchants.length > 0) {
            setMerchantData(matchingMerchants);
            setMerchantValue(matchingMerchants[0]?.id);
          }
        }
      }

      const getCustomerProfile: CustomerProfileModel[] = resCustomerProfile?.data?.data;
      const getCoupons: CouponHistoryModel[] = couponRes?.data;
      setCouponData(
        getCoupons?.map((item: CouponHistoryModel) => {
          const populateCustomer: CustomerProfileModel[] = getCustomerProfile.filter(
            (subItem) => subItem?.customer?.id === item?.customerId
          );
          return {
            ...item,
            customer: populateCustomer?.length > 0 ? populateCustomer[0] : null!,
          };
        })
      );
    } catch (err) {
      // console.log(err);
    }
  };

  const handleGetData = async () => {
    try {
      await handleFetchData();
    } catch (err) {
    } finally {
      setLoadingData(false);
    }
  };

  //-----------end ---------------//

  //-----------function ----------//

  const handleChangePage = (_: any, newPage: any) => {
    setCurrentPage(newPage);
  };

  const handleSelectMerchant = (event: SelectChangeEvent) => {
    setMerchantValue(event.target.value);
  };

  const handleChangeDate = (event: any) => {
    setDate(event.target.value);
    setCurrentPage(1);
  };

  const handleSearchValue = (e: any) => {
    setCurrentPage(1);
    setSearchValue(e.target.value);
  };

  //------------end --------------//

  //-----------filter ------------//
  const sortedData = couponData.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  const filterDataByBranch: CouponHistoryModel[] = sortedData?.filter(
    (item: CouponHistoryModel) =>
      merchantData
        .filter((subItem) => subItem?.id === item?.merchantId)
        ?.filter((merchant) => merchant?.id === merchantValue)?.length > 0
  );

  const filterByDate: CouponHistoryModel[] = filterDataByBranch?.filter(
    (item: CouponHistoryModel) => {
      if (date) {
        return (
          convertDateStringToNormalString(item?.createdAt) ===
          moment(new Date(date)).format('DD/MM/YYYY')
        );
      }
      return true;
    }
  );

  const filterData: CouponHistoryModel[] = filterByDate.filter(
    (item: CouponHistoryModel) =>
      item?.couponCode?.toLowerCase()?.includes(searchValue.toLowerCase()) ||
      item?.customer?.profile?.fullName?.toLowerCase()?.includes(searchValue.toLowerCase())
  );

  const rows: CouponHistoryModel[] = filterData?.slice((currentPage - 1) * 10, currentPage * 10);

  const countPagination = Math.ceil(filterData?.length / 10);
  const isSearchNotFound = !filterData.length && !!searchValue;

  //------------end --------------//

  //---------useEffect------------//
  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //-----------end ---------------//

  return {
    loadingData,
    rows,
    countPagination,
    handleChangePage,
    currentPage,
    handleSelectMerchant,
    merchantValue,
    merchantData,
    handleChangeDate,
    date,
    adminRole,
    handleSearchValue,
    searchValue,
    isSearchNotFound,
  };
};
export default useCouponHistoryController;
